import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";

export interface NotificationConfig {
  smtp_host: string;
  smtp_port: number;
  smtp_user: string;
  smtp_pass: string;
  smtp_sender: string;
  vapid_public_key: string;
  vapid_private_key: string;
  web_push_enabled: boolean;
  email_enabled: boolean;
}

export function useNotificationSettings() {
  const queryClient = useQueryClient();

  const { data: config, isLoading } = useQuery({
    queryKey: ["admin-notification-config"],
    queryFn: async () => {
      const res = await apiClient.get("/notifications/admin/config");
      return res.data.data as NotificationConfig;
    },
  });

  const updateConfig = useMutation({
    mutationFn: async (data: NotificationConfig) => {
      const res = await apiClient.post("/notifications/admin/config", data);
      return res.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin-notification-config"] });
    },
  });

  return { config, isLoading, updateConfig };
}
